/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
	FacultyDTO,
	FacultyDTOFromJSON,
	FacultyDTOFromJSONTyped,
	FacultyDTOToJSON,
} from "./FacultyDTO";

/**
 *
 * @export
 * @interface FacultyDTOPagedResponse
 */
export interface FacultyDTOPagedResponse {
	/**
	 *
	 * @type {number}
	 * @memberof FacultyDTOPagedResponse
	 */
	page?: number;
	/**
	 *
	 * @type {number}
	 * @memberof FacultyDTOPagedResponse
	 */
	pageSize?: number;
	/**
	 *
	 * @type {number}
	 * @memberof FacultyDTOPagedResponse
	 */
	totalCount?: number;
	/**
	 *
	 * @type {Array<FacultyDTO>}
	 * @memberof FacultyDTOPagedResponse
	 */
	data?: Array<FacultyDTO> | null;
}

export function FacultyDTOPagedResponseFromJSON(
	json: any
): FacultyDTOPagedResponse {
	return FacultyDTOPagedResponseFromJSONTyped(json, false);
}

export function FacultyDTOPagedResponseFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): FacultyDTOPagedResponse {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		page: !exists(json, "page") ? undefined : json["page"],
		pageSize: !exists(json, "pageSize") ? undefined : json["pageSize"],
		totalCount: !exists(json, "totalCount") ? undefined : json["totalCount"],
		data: !exists(json, "data")
			? undefined
			: json["data"] === null
			? null
			: (json["data"] as Array<any>).map(FacultyDTOFromJSON),
	};
}

export function FacultyDTOPagedResponseToJSON(
	value?: FacultyDTOPagedResponse | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		page: value.page,
		pageSize: value.pageSize,
		totalCount: value.totalCount,
		data:
			value.data === undefined
				? undefined
				: value.data === null
				? null
				: (value.data as Array<any>).map(FacultyDTOToJSON),
	};
}
